import { defineMessages } from 'react-intl'

export default defineMessages({
    wizard_create: {
        id: 'app.titles.wizard.create',
        defaultMessage: 'Выбор режима',
    },
    wizard_rebuild: {
        id: 'app.titles.wizard.rebuild',
        defaultMessage: 'Смена режима',
    },
    postbattle: {
        id: 'app.titles.offensiveResult',
        defaultMessage: 'Результаты наступления',
    },
    challenges_results: {
        id: 'app.titles.challengesResults',
        defaultMessage: 'Результаты Военных игр',
    },
    schedule: {
        id: 'app.titles.schedule',
        defaultMessage: 'Расписание сражений',
    },
})



// WEBPACK FOOTER //
// ./window_titles.js